import React, {useEffect} from "react";
import { useTournamentStore } from '../../../service/useTournamentStore';
import {useGetHeatsResults} from "../hooks/heatResultHooks";
import {useTranslation} from "react-i18next";
import {Printer} from "lucide-react";
import { useNotification } from '@iziping/ui';
import "../dashboard.css";
import "./tournamentResults.css";

const TournamentResults: React.FC = () => {
    const {selectedTournament} = useTournamentStore();
    const {t} = useTranslation();
    const {notify} = useNotification();
    const {data: heatsResults, isLoading, isError, error} = useGetHeatsResults({
        tournamentId: Number(selectedTournament?.id),
    });

    useEffect(() => {
        if (isError && error) {
            notify(t(error.error), "error");
        }
    }, [isError, error]);

    if (!selectedTournament) {
        return <div className="resultsEmpty">{t("statistics.results.no.tournament")}</div>;
    }

    if (isLoading) {
        return <div className="resultsEmpty">{t("statistics.results.loading")}</div>;
    }

    if (isError) {
        return <div className="resultsEmpty resultsError">{t("statistics.results.error")}</div>;
    }

    if (!heatsResults || heatsResults.length === 0) {
        return <div className="resultsEmpty">{t("statistics.results.empty")}</div>;
    }

    return (
        <>
            <div className="resultsHeader no-print">
                <h2 className="resultsTitle">
                    Classement des séries — {selectedTournament.name}
                </h2>
                <button className="resultsPrintButton" onClick={() => window.print()} title="Exporter en PDF">
                    <Printer size={18}/>
                </button>
            </div>
            <div className="resultsWrapper">
                {heatsResults.map((heatRanking) => (
                    <div key={heatRanking.heat.id} className="chartCard">
                        <h3 className="chartTitle">{heatRanking.heat.name}</h3>
                        {heatRanking.ranksForHeat.length === 0 ? (
                            <p className="resultsNoData">{t("statistics.results.heat.empty")}</p>
                        ) : (
                            <ol className="resultsList">
                                {heatRanking.ranksForHeat.map((entry, index) => (
                                    <li key={index} className={`resultsItem rank-${index + 1}`}>
                                        <span className="resultsRank">{index + 1}</span>
                                        <span className="resultsPlayer">{entry.description}</span>
                                    </li>
                                ))}
                            </ol>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default TournamentResults;